import SubHeader from "../../components/layouts/SubHeader";
import React, {useEffect, useState} from "react";
import MainLayout from "../../components/layouts/MainLayout";
import { FIXED_HEADER_OFFSET } from "../../components/layouts/headerLayout";
import {Box, Divider, Grid, Typography} from "@mui/material";
import styled from "@emotion/styled";
import {useParams} from "react-router-dom";
import CompanyDetailSection from "./CompanyDetailSection";
import {getCompanyDetail, registerCompanyInquiry} from "../../api/companyApi";
import {addBackground, loadJimp} from "../../helper/image_processing";
import Link from '@mui/material/Link';
import defaultImageUrl from "../../assets/defaultImage.svg";
import MultiSourceDataPointChip from "../../components/Common/MultiSourceDataPointChip";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LanguageIcon from "@mui/icons-material/Language";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import {SocialMediaBar} from "../../components/Common/SocialMediaBar";
import {removeDuplicateLocations} from "../../helper/address";
import {HqChip} from "../../components/Common/HqChip";
import {LocationCard} from "../../components/Common/LocationCard";
import NoInfoCard from "../../components/Common/NoInfoCard";
import {SectorDisplayCard} from "../../components/Common/SectorDisplayCard";
import {NarrativeCard} from "../../components/Common/NarrativeCard";
import {optBoolToDes} from "../../helper/formatting";
import CompanyListCard from "../../components/Common/CompanyListCard";
import CompanyDetailGrid from "./CompanyDetailGrid";
import PersonCard from "../../components/Common/PersonCard";
import NoCompanySpecified from "./NoCompanySpecified";
import CompanyMetricsPanelV2 from "../../components/CompanyModal/v2/CompanyMetricsPanelV2";

const Wrapper = styled(Grid)(() => ({
  padding: `${FIXED_HEADER_OFFSET} 0px 0px 0px`,
  //  background: "#F2F3F4",
  "@media (max-width: 900px)": {
    // Styles for screens with a maximum width of 768px
    padding: `${FIXED_HEADER_OFFSET} 0px 0px 0px`,
  },
}));

export const CompanyDetailPage = () => {

  const [selectedCompanyData, setSelectedCompanyData] = useState(null);
  const [imageData, setImageData] = useState(defaultImageUrl);

  const {stagedId} = useParams();

  useEffect(() => {
    const handleSelectedCompanyChange = () => {
      if (stagedId) {
        getCompanyDetail(stagedId)
          .then(response => {
            setSelectedCompanyData(response?.data);
          })
          .then(registerCompanyInquiry(stagedId))
      }
    }
    handleSelectedCompanyChange()
  }, [stagedId]);


  useEffect(() => {
      const getCompanyLogo = async (uri) => {
        if (uri) {
        // We don't want to use zoominfo image processing...
        const unprocessed_uri = uri.replace("w_70,h_70,c_fit", "")
        const Jimp = await loadJimp();

        await Jimp.read(unprocessed_uri)
          .then(image => image
            .autocrop()
            .scaleToFit(70, 70))
          .then(processed =>
            processed.getBase64Async(Jimp.MIME_PNG))
          .then(imageString => {
            addBackground(imageString, 74, 74)
            .then(withBg => {
              if (withBg) {
                setImageData(withBg)
              } else {
                setImageData(imageString)
              }
            })
          })
          .catch((err) => {
            console.log(err)
          });
        }
      }
      getCompanyLogo(selectedCompanyData?.primaryLogo)
    }, [selectedCompanyData]);

    let filtered;
    if (selectedCompanyData?.otherLocations && selectedCompanyData.otherLocations.length > 0) {
      filtered = removeDuplicateLocations(selectedCompanyData?.primaryLocation, selectedCompanyData?.otherLocations)
    } else {
      filtered = null
    }



  return (
    <MainLayout>
      <Wrapper>
        <SubHeader/>
        <Box sx={{ marginY: "25px", marginX: { xs: 2, md: "50px" } }}>
          { selectedCompanyData
            ?
              <Box
                sx={{flexGrow: 1}}
              >
                <Grid container gap={"13px"} alignItems={"center"} sx={{mb: "25px"}}>
                  <Grid item>
                    <img
                      src={imageData}
                      height="74px"
                      width="74px"
                      alt="logo"
                      style={{
                        borderRadius: "12px",
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <Grid item>
                      <Typography
                        variant={"h1"}
                        sx={{
                          fontSize: { xs: 22, md: undefined },
                          lineHeight: { xs: 1.25, md: undefined },
                          overflowWrap: "anywhere",
                        }}
                      >
                        {selectedCompanyData?.primaryName}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "1fr 100px" },
                    gap: { xs: 1.5, sm: 0 },
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      pb: "5px",
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 1,
                      rowGap: 1,
                      minWidth: 0,
                      overflowX: { xs: "auto", sm: "visible" },
                      WebkitOverflowScrolling: "touch",
                    }}
                  >
                    {selectedCompanyData?.primaryTelephone &&
                      <MultiSourceDataPointChip
                        dataPointName={"phone number"}
                        primaryDataPoint={selectedCompanyData?.primaryTelephone}
                        alternateDataPoints={selectedCompanyData?.alternateTelephones}
                        maxDataWidth={"120px"}
                        mr={"8px"}
                        iconRenderer={
                          (props) => {
                            return (
                              <LocalPhoneIcon
                                sx={{
                                  color: props.color,
                                  height: props.height,
                                  width: props.width
                                }}
                              />
                            )
                          }
                        }
                      />
                    }
                    {selectedCompanyData?.primaryWebsite &&
                      <MultiSourceDataPointChip
                        dataPointName={"website"}
                        primaryDataPoint={selectedCompanyData?.primaryWebsite}
                        alternateDataPoints={selectedCompanyData?.alternateWebsites}
                        iconLink={
                          selectedCompanyData?.primaryWebsite.includes("http", 0)
                            ? selectedCompanyData?.primaryWebsite
                            : `https://${selectedCompanyData?.primaryWebsite}`}
                        maxDataWidth={"250px"}
                        mr={"8px"}
                        iconRenderer={
                          (props) => {
                            return (
                              <LanguageIcon
                                sx={{
                                  color: props.color,
                                  height: props.height,
                                  width: props.width
                                }}
                              />
                            )
                          }
                        }
                      />
                    }
                    {selectedCompanyData?.stagedId &&
                      <MultiSourceDataPointChip
                        primaryDataPoint={selectedCompanyData?.stagedId}
                        dataPointMargins={"0px"}
                        dataPointName={"Alphasearch ID"}
                        maxDataWidth={"200px"}
                        mr={"8px"}
                        iconRenderer={
                          (props) => {
                            return (
                              <FingerprintIcon
                                sx={{
                                  color: props.color,
                                  height: props.height,
                                  width: props.width
                                }}
                              />
                            )
                          }
                        }
                      />
                    }
                  </Box>
                  <Box
                    sx={{
                      alignItems: "center",
                      alignContent: "center",
                      alignSelf: { xs: "flex-start", sm: "center" },
                      justifySelf: { xs: "flex-start", sm: "center" },
                      justifyContent: { xs: "flex-start", sm: "center" },
                      justifyItems: "center",
                      pb: "5px"
                    }}
                  >
                    <SocialMediaBar
                      links={{
                        linkedin: selectedCompanyData?.social?.linkedinUrl,
                        instagram: selectedCompanyData?.social?.instagramUrl,
                        twitter: selectedCompanyData?.social?.twitterUrl,
                        facebook: selectedCompanyData?.social?.facebookUrl,
                      }}
                      justifyContent={"flex-start"}
                      iconSize="24px"
                    />
                  </Box>
                </Box>

                <Divider sx={{marginTop: "0px", marginBottom: "0px"}}/>

                <CompanyDetailGrid>

                  {/* Contact */}
                  <Grid sx={{gridArea: "contact"}}>
                    <CompanyDetailSection title="Contact" padding={"15px"}>
                      <Typography variant={"h6"}>
                        Email:
                      </Typography>
                      <Typography variant={"body1"} component="div" sx={{pb: 2}}>
                        {(selectedCompanyData?.emails && selectedCompanyData.emails.length > 0) ? (
                          selectedCompanyData.emails.map((email, index) => (
                            <React.Fragment key={email}>
                              <Link href={`mailto:${email}`}>{email}</Link>
                              {index < selectedCompanyData.emails.length - 1 ? ', ' : ''}
                            </React.Fragment>
                          ))
                        ) : (
                          "No email available"
                        )}
                      </Typography>

                      <Typography variant={"h6"}>
                        Phone:
                      </Typography>
                      <Typography variant={"body1"}>
                        {selectedCompanyData?.primaryTelephone || "No phone available"}
                      </Typography>

                    </CompanyDetailSection>
                  </Grid>

                  {/* Location */}
                  <Grid sx={{gridArea: "location"}}>
                    <CompanyDetailSection title="Location" padding={"15px"}>
                      <Typography sx={{pb: "8px"}} variant={"h6"}>
                        Primary address: {(selectedCompanyData.isHq) ? HqChip : <></>}
                      </Typography>
                      { (selectedCompanyData?.primaryLocation)
                        ?
                          <LocationCard
                            location={selectedCompanyData?.primaryLocation}
                            mb={"10px"}
                            expanded={true}
                          />
                        :
                          <NoInfoCard/>
                      }
                      { (filtered && filtered.length > 0) &&
                        <>
                          <Typography sx={{pb: "8px"}} variant={"h6"}>
                            Other addresses:
                          </Typography>
                          {filtered.map(function(adr) {
                            return(<LocationCard location={adr} mb={"10px"} expanded={false}/>)
                          })}
                        </>
                      }
                    </CompanyDetailSection>
                  </Grid>

                  {/* Classification */}
                  <Grid sx={{gridArea: "classification"}}>
                    <CompanyDetailSection title="Classification" padding={"15px"}>
                      <Typography sx={{pb: "8px"}} variant={"h6"}>
                        From online sources:
                      </Typography>
                      {selectedCompanyData?.sourcedClassifications
                        ? selectedCompanyData?.sourcedClassifications?.map((classification) => {
                            return(<SectorDisplayCard levels={classification.levels}/>)
                          })
                        : <NoInfoCard/>
                      }
                      <Typography sx={{pt: "8px", pb: "8px"}} variant={"h6"}>
                        AlphaSearch AI:
                      </Typography>
                      {selectedCompanyData?.modeledClassifications && selectedCompanyData.modeledClassifications.length > 0
                        ? selectedCompanyData?.modeledClassifications?.map((classification) => {
                            return(<SectorDisplayCard levels={classification.levels}/>)
                          })
                        : <NoInfoCard/>
                      }
                    </CompanyDetailSection>
                  </Grid>


                  {/* Descriptive */}
                  <Grid sx={{gridArea: "descriptive"}}>
                    <CompanyDetailSection title="Descriptive" padding={"15px"}>
                      <Typography sx={{pb: "8px"}} variant={"h6"}>
                        Key words/terms/phrases:
                      </Typography>
                      { selectedCompanyData?.keywords ? (
                        <NarrativeCard description={selectedCompanyData.keywords.join(", ")}/>
                      ) : (
                        <NoInfoCard/>
                      )}
                      <Typography sx={{pt: "8px", pb: "8px"}} variant={"h6"}>
                        Descriptions from online sources:
                      </Typography>
                      { selectedCompanyData?.descriptive ? (
                        selectedCompanyData?.descriptive?.map((narrative) => {
                            return(<NarrativeCard description={narrative}/>)
                        })
                      ) : (
                        <NoInfoCard/>
                      )}
                    </CompanyDetailSection>
                  </Grid>

                  {/* Similar Companies */}
                  <Grid sx={{gridArea: "similar"}}>
                    <CompanyDetailSection title="Similar Companies" padding={"15px"}>
                      {selectedCompanyData?.similarCompanies?.map((id) => {
                        return <CompanyListCard id={id}/>
                      })}
                    </CompanyDetailSection>
                  </Grid>

                  {/* People */}
                  <Grid sx={{gridArea: "people"}}>
                    <CompanyDetailSection title="People" padding={"15px"}>
                      { (selectedCompanyData?.people && selectedCompanyData.people?.length > 0)
                        ?
                          selectedCompanyData?.people?.map(function(person) {
                            return(<PersonCard {...person}/>)
                          })
                        :
                          <NoInfoCard/>
                      }
                    </CompanyDetailSection>
                  </Grid>

                  {/* Incorporation */}
                  <Grid sx={{gridArea: "incorporation"}}>
                    <CompanyDetailSection title="Incorporation" padding={"15px"}>
                      <Box
                        sx={{
                          maxWidth: "500px",
                          display: 'grid',
                          gap: 2,
                          gridTemplateColumns: 'repeat(2, 1fr)',
                          gridTemplateRows: 'auto',
                        }}
                      >
                        <Box sx={{textAlign: "left"}}>
                          <Typography variant="h6">
                            Domicile
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "right"}}>
                          <Typography variant="body1">
                            {selectedCompanyData?.incorporation?.domicile}
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "left"}}>
                          <Typography variant="h6">
                            Legal Form
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "right"}}>
                          <Typography variant="body1">
                            {selectedCompanyData?.incorporation?.legalForm}
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "left"}}>
                          <Typography variant="h6">
                            Marketablility
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "right"}}>
                          <Typography variant="body1">
                            {selectedCompanyData?.incorporation?.marketability}
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "left"}}>
                          <Typography variant="h6">
                            For Profit?
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "right"}}>
                          <Typography variant="body1">
                            {optBoolToDes(selectedCompanyData?.incorporation?.forProfit)}
                          </Typography>
                        </Box>
                      </Box>
                    </CompanyDetailSection>
                  </Grid>

                  {/* Socioeconomic */}
                  <Grid sx={{gridArea: "socioeconomic"}}>
                    <CompanyDetailSection title="Socioeconomic" padding={"15px"}>
                      <Box
                        sx={{
                          maxWidth: "500px",
                          display: 'grid',
                          gap: 2,
                          gridTemplateColumns: 'repeat(2, 1fr)',
                          gridTemplateRows: 'auto',
                        }}
                      >
                        <Box sx={{textAlign: "left"}}>
                          <Typography variant="h6">
                            Hispanic or Latino
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "right"}}>
                          <Typography variant="body1">
                            {optBoolToDes(selectedCompanyData?.socioeconomic?.hispanicOrLatino)}
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "left"}}>
                          <Typography variant="h6">
                            Female
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "right"}}>
                          <Typography variant="body1">
                            {optBoolToDes(selectedCompanyData?.socioeconomic?.female)}
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "left"}}>
                          <Typography variant="h6">
                            Veteran
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "right"}}>
                          <Typography variant="body1">
                            {optBoolToDes(selectedCompanyData?.socioeconomic?.veteran)}
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "left"}}>
                          <Typography variant="h6">
                            Minority
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "right"}}>
                          <Typography variant="body1">
                            {optBoolToDes(selectedCompanyData?.socioeconomic?.minority)}
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "left"}}>
                          <Typography variant="h6">
                            Hubzone
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "right"}}>
                          <Typography variant="body1">
                            {optBoolToDes(selectedCompanyData?.socioeconomic?.hubzone)}
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "left"}}>
                          <Typography variant="h6">
                            Low/Moderate Income
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "right"}}>
                          <Typography variant="body1">
                            {optBoolToDes(selectedCompanyData?.socioeconomic?.lowOrModerateIncome)}
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "left"}}>
                          <Typography variant="h6">
                            Rural
                          </Typography>
                        </Box>
                        <Box sx={{textAlign: "right"}}>
                          <Typography variant="body1">
                            {optBoolToDes(selectedCompanyData?.socioeconomic?.rural)}
                          </Typography>
                        </Box>
                      </Box>
                    </CompanyDetailSection>
                  </Grid>

                  {/* Franchise */}
                  <Grid sx={{gridArea: "franchise"}}>
                    <CompanyDetailSection title="Franchise" padding={"15px"}>
                      {selectedCompanyData?.franchise?.franchiseName ? (
                        <>
                          <Typography variant={"h6"}>
                            This entity operates franchises of the following type(s):
                          </Typography>
                          <br/>
                          <Typography variant={"body1"}>
                            {selectedCompanyData?.franchise?.franchiseName}
                          </Typography>
                        </>
                      ) : (
                        <NoInfoCard/>
                      )}
                    </CompanyDetailSection>
                  </Grid>

                </CompanyDetailGrid>
                  <Box
                    sx={{
                      mt: 2,
                      p: { xs: 1.5, md: 2 },
                      border: "1px solid rgba(88, 89, 91, 0.14)",
                      borderRadius: "12px",
                      bgcolor: "background.paper",
                    }}
                  >
                    <CompanyMetricsPanelV2 companyDetail={selectedCompanyData} />
                  </Box>

              </Box>
            :
              <Box sx={{width: 1, display: "flex", justifyContent: "center"}}>
                <NoCompanySpecified/>
              </Box>
          }
        </Box>
      </Wrapper>
    </MainLayout>
  )
}
